<template>
  <div class="indexPage">
    <div class="banner">
      <img src="../../../assets/images/banner3.png" alt="" />
    </div>
    <div class="breadcrumb flex-rowc">
      <div class="breadcrumb_icon4"><i class="iconfont icon-yonghu"></i></div>
      <div class="breadcrumb_item">业务资源管理</div>
      <div class="breadcrumb_item_arrow"></div>
      <div class="breadcrumb_item">客户企业管理</div>
    </div>

    <div class="input_wrap flex-rowl">
      <div class="input_box search">
        <van-field
          v-model="params.keyword"
          ref="input"
          placeholder="输入关键字查找→"
          @focus="handleFocus"
          @blur="handleBlur"
          @keyup.enter="handleSearch"
        />
      </div>
      <div class="primary-button" @click="handleSearch">查找→</div>
    </div>

    <div class="customer_wrap">
      <div class="customer_list" v-if="dataList.length > 0">
        <div
          class="customer_item"
          v-for="(item, index) in dataList"
          :key="index"
          @click="handleDetail(item.id)"
        >
          <div class="item">
            <div class="txt flex-rowl">
              <p class="label">客户企业名称：</p>
              <p>
                {{ item.bodyname }}
              </p>
            </div>
            <div class="txt flex-rowl">
              <p class="label">所属企业名称：</p>
              <p>{{ item.qyname }}</p>
            </div>
            <div class="txt flex-rowl">
              <p class="label">所在地区：</p>
              <p>
                <span>{{ item.bodyprovincestr }}</span>
                <span>{{ item.bodycitystr }}</span>
                <span>{{ item.bodyareastr }}</span>
                <span>{{ item.bodyaddr }}</span>
              </p>
            </div>
            <div class="txt flex-rowl">
              <p class="label">行业标签：</p>
              <p>
                <span v-if="item.label1str">{{ item.label1str }}</span>
                <span v-if="item.label2str">、{{ item.label2str }}</span>
                <span v-if="item.label3str">、{{ item.label3str }}</span>
              </p>
            </div>
            <div class="txt flex-rowl">
              <p class="label">是否启用：</p>
              <p class="red">
                <span>{{ item.isuse == 1 ? "启用" : "停用" }}</span>
              </p>
            </div>
          </div>
        </div>
      </div>
      <van-empty
        v-else-if="dataList.length == 0 && !loading"
        description="暂无数据"
      />
    </div>

    <div class="fixd_button_btm flex-rowl" v-if="isShowTabbar">
      <div class="item return" @click="handleReturn">返回</div>
      <div class="item" @click="handleDetail('')">新增企业客户</div>
    </div>
  </div>
</template>

<script>
import { encryptstringadd, getCustomerBodyList } from "../../../api/api";
import { mapState } from "vuex";
export default {
  name: "customerList",
  data() {
    return {
      isShowTabbar: true,
      type: 1,
      dataList: [],
      params: {
        qyguid: "",
        keyword: "",
      },
      listTotal: 0,
      loading: false, // 是否正在加载
    };
  },
  filters: {
    // 时间格式化
    formatDate(date) {
      if (!date) return "";
      if (date.indexOf("T") != -1) {
        let dateSplit = date.split("T");
        let dataTime =
          dateSplit[1].indexOf(".") != -1
            ? dateSplit[1].split(".")[0]
            : dateSplit[1];
        return dateSplit[0] + " " + dataTime; // 这里可以根据需要使用不同的日期格式化选项
      } else {
        return date;
      }
    },
  },
  computed: {
    ...mapState(["OPENID"]),
  },
  created() {
    let { USERINFO } = this.$store.state;
    this.params.qyguid = USERINFO.qy.qyguid;
    this.getCustomerBodyList();
  },
  methods: {
    handleSearch() {
      this.getCustomerBodyList();
    },

    // 获取数据
    getCustomerBodyList() {
      const Toast = this.$toast.loading({
        message: "加载中...",
        forbidClick: true,
      });
      this.loading = true;
      getCustomerBodyList(this.params).then((res) => {
        res.list.sort((a, b) => {
          const dateA = new Date(a.addtime);
          const dateB = new Date(b.addtime);
          return dateB - dateA; // 按照时间从大到小排序
        });
        this.dataList = res.list;
        this.listTotal = res.total;
        Toast.clear();
      });
    },

    handleReturn() {
      history.back();
    },
    // 获取焦点
    handleFocus() {
      this.isShowTabbar = false;
    },
    // 失去焦点
    handleBlur() {
      this.isShowTabbar = true;
    },

    handleDetail(id) {
      if (id) {
        this.encryptstringadd("customerDetail", { id });
        // this.$router.push({ path: "/brandIndex/brandDetail", query: { id } });
      } else {
        this.encryptstringadd("customerDetail", "");
      }
    },
    // 页面跳转之前对参数进行加密
    async encryptstringadd(name, params) {
      if (params != "") {
        let paramsData = {
          openid: this.OPENID,
          jsondata: JSON.stringify(params),
        };
        const response = await encryptstringadd(paramsData);
        if (response.result) {
          this.$store.commit("cacheRoute", {
            encryptstring: response.encryptstring,
            name,
          });
          this.$router.push({
            name,
            params,
          });
        }
      } else {
        this.$store.commit("cacheRoute", {
          encryptstring: "",
          name,
        });
        this.$router.push({
          name,
          params,
        });
      }
    },
  },
};
</script>
<style lang="less" scoped>
.indexPage {
  box-sizing: border-box;
  padding-bottom: 190px;
  .screen_wrap {
    padding: 50px;
    font-size: 20px;
    color: #464646;
    .screen_list {
      .screen_item {
        flex-shrink: 0;
        height: 40px;
        line-height: 40px;
        min-width: 90px;
        max-width: 160px;
        padding: 0 10px 0 20px;
        border: 1px solid #d2d2d2;
        box-sizing: border-box;
        margin-right: 10px;
        .iconfont {
          margin-left: 10px;
        }
      }
      &:last-child {
        margin-top: 20px;
      }
      &.screen_list_one {
        .screen_item {
          width: 210px;
          &:first-child {
            width: 190px;
            max-width: 190px;
          }
        }
      }
    }
  }
  .input_wrap {
    padding: 0 45px 40px;
    box-sizing: border-box;
    .primary-button {
      width: 145px;
      margin-left: 20px;
      font-size: 26px;
    }
  }
  .customer_wrap {
    font-size: 22px;
    color: #3c3c3c;
    width: 650px;
    margin: 0 auto 30px;
    .red {
      color: #ff0036;
    }
    .customer_list {
      .customer_item {
        margin-bottom: 30px;
        border: 1px solid #d2d2d2;
        padding: 40px;
        box-sizing: border-box;
      }
      .item {
        .txt {
          margin-bottom: 15px;
          align-items: flex-start;
          &:last-child {
            margin-bottom: 0;
          }
          .label {
            white-space: nowrap;
            width: 160px;
            flex-shrink: 0;
          }
          .label_list {
            .label_item {
              border: 1px solid #d2d2d2;
              padding: 5px 10px 5px 20px;
              margin-right: 10px;
            }
          }
        }
        &.address {
          .tit {
            margin-bottom: 10px;
          }
          .txt {
            font-size: 20px;
            p {
              &:nth-child(2) {
                margin: 0 30px;
              }
            }
          }
        }
        p {
          line-height: 28px;
        }
      }
    }
  }

  .custom_popup {
    z-index: 1000002 !important;
  }
}
</style>